import React, { Component } from 'react'
import Heading from 'grommet/components/Heading'
import Waypoint from 'react-waypoint'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { connect } from 'react-redux'
import { setSectionProperty, setParticleVisibility } from '../../actions/sections/SectionsActions'
import ReactLogo from '../../resources/images/react-logo.svg'
import NodeLogo from '../../resources/images/Node.js_logo-v2.svg'
import GithubLogo from '../../resources/images/Octocat-v2.svg'
import SketchLogo from '../../resources/images/Sketch_logo_frame-v2.svg'
import './TechnologiesCarousel.css'

@connect((state) => ({
  technologiesVisible: state.sectionsReducer.technologies.isVisible
}), { setSectionProperty, setParticleVisibility })
class TechnologiesCarousel extends Component {

  handleWaypointEnter = () => {
    const { setSectionProperty, setParticleVisibility } = this.props
    setSectionProperty('technologies', 'isVisible', true)
    setParticleVisibility('home', 'sectionOneParticlesVisible', false)
    setParticleVisibility('home', 'sectionTwoParticlesVisible', true)
  }

  handleWaypointLeave = () => {
    const { setSectionProperty } = this.props
    setSectionProperty('technologies', 'isVisible', false)
  }

  render() {
    const { technologiesVisible } = this.props
    return (
      <div className="TechnologiesCarousel">
        <Heading tag="h2" uppercase={true} strong={true} className="Services-title">Technologies</Heading>
        <div className="TechnologiesCarousel-container">
          <Waypoint scrollableAncestor={window} onEnter={this.handleWaypointEnter} onLeave={this.handleWaypointLeave}>
            <div style={{height: '100%'}}>
              <TransitionGroup style={{height: '100%'}}>
              { technologiesVisible &&
                <CSSTransition
                  key="technologies"
                  classNames="TechnologiesCarousel"
                  timeout={{}}
                  >
                  <div key="items" className="TechnologiesCarousel-items">
                    <div className="TechnologiesCarousel-block">
                      <div className="TechnologiesCarousel-logoContainer TechnologiesCarousel-logoContainer--react">
                        <a className="TechnologiesCarousel-link" href="https://reactjs.org" target="_blank" rel="noopener noreferrer">
                          <img className="TechnologiesCarousel-logoImage TechnologiesCarousel-logoImage--react" src={ReactLogo} alt="React"/>
                          <span className="TechnologiesCarousel-title">React</span>
                        </a>
                      </div>
                      <div className="TechnologiesCarousel-logoContainer TechnologiesCarousel-logoContainer--node">
                        <a className="TechnologiesCarousel-link" href="https://nodejs.org/en/" target="_blank" rel="noopener noreferrer">
                          <img className="TechnologiesCarousel-logoImage TechnologiesCarousel-logoImage--node" src={NodeLogo} alt="Node.js"/>
                          <span className="TechnologiesCarousel-title">Node.js</span>
                        </a>
                      </div>
                    </div>
                    <div className="TechnologiesCarousel-block">
                      <div className="TechnologiesCarousel-logoContainer TechnologiesCarousel-logoContainer--github">
                        <a className="TechnologiesCarousel-link" href="https://github.com" target="_blank" rel="noopener noreferrer" >
                          <img className="TechnologiesCarousel-logoImage TechnologiesCarousel-logoImage--github" src={GithubLogo} alt="Github"/>
                          <span className="TechnologiesCarousel-title">Github</span>
                        </a>
                      </div>
                      <div className="TechnologiesCarousel-logoContainer TechnologiesCarousel-logoContainer--sketch">
                        <a className="TechnologiesCarousel-link" href="https://www.sketchapp.com/" target="_blank" rel="noopener noreferrer">
                          <img className="TechnologiesCarousel-logoImage TechnologiesCarousel-logoImage--sketch" src={SketchLogo} alt="Sketch"/>
                          <span className="TechnologiesCarousel-title">Sketch</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </CSSTransition>}
              </TransitionGroup>
            </div>
          </Waypoint>
        </div>
      </div>
    )
  }
}

export default TechnologiesCarousel


// WEBPACK FOOTER //
// ./src/components/TechnologiesCarousel/index.js